<div class="panorama-body">
  <!-- Panorama Viewer Div -->
  <div [id]="pluginName" class="viewer">
  </div>
</div>
